export enum BeneficialOwnerStep {
  IntetionWithGoods,
  CompanyDetails,
  OtherDetails,
  VatNumber,
  Ownership,
  Confirmation,
}
